// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../../graphql/api/index';

export const QuestionnaireQuestionPriceFragmentDoc = `
    fragment questionnaireQuestionPrice on QuestionnaireQuestionPrice {
  id
  title
  required
  tooltip
  min
  max
}
    `;